import { FC, ReactNode } from 'react';

import {
  TranscriptContextProvider,
  TranscriptContextProviderProps,
} from '../../store/transcript/store';
import { ChatHeader, ChatHeaderProps } from '../ChatHeader/ChatHeader';
import { MessageInputBox, MessageInputBoxProps } from '../MessageInputBox/MessageInputBox';
import { Transcript, TranscriptProps } from '../TranscriptBox/Transcript';
import { ChatLayout } from './ChatLayout';

export type ChatInnerProps = ChatHeaderProps &
  TranscriptProps & {
    footer?: ReactNode;
    inputPlaceholder?: string;
    resetButton?: MessageInputBoxProps['resetButton'];
  };

export const ChatInner: FC<ChatInnerProps> = (props) => {
  return (
    <ChatLayout>
      {(props.title || props.branding || props.showBetaBadge) && 
        <ChatHeader 
          title={props.title} 
          branding={props.branding} 
          showBetaBadge={props.showBetaBadge}
        />}
      <Transcript
        loadingMessage={props.loadingMessage}
        renderMessage={props.renderMessage}
        renderAdditionalActions={props.renderAdditionalActions}
        renderAdditionalMessageUI={props.renderAdditionalMessageUI}
        transcriptFooter={props.transcriptFooter}
        assistantName={props.assistantName}
        avatarUrl={props.avatarUrl}
      />
      <MessageInputBox 
        placeholder={props.inputPlaceholder}
        resetButton={props.resetButton}
      />
      {props.footer && props.footer}
    </ChatLayout>
  );
};

export type ChatProps = ChatInnerProps &
  Omit<TranscriptContextProviderProps, 'children'>;

export const Chat: FC<ChatProps> = (props) => {
  return (
    <TranscriptContextProvider {...props}>
      <ChatInner {...props} />
    </TranscriptContextProvider>
  );
};
